import React, { createContext, useReducer, useContext } from "react";

const Context = createContext();

const StateProvider = (props) => {
  return (
    <Context.Provider value={useReducer(props.reducer, props.initialstate)}>
      {props.children}
    </Context.Provider>
  );
};

export const StateContext = () => {
  return useContext(Context);
};

export default StateProvider;
